import http from '../axios'

export default {

  // 批量修改投放日期（广告组id）
  batchUpdateDeliveryDate(data) {
    return http({
      url: '/vivo-accounts/batchUpdateDeliveryDate',
      method: 'post',
      data,
    })
  },

  // 批量修改投放时段
  batchUpdateDeliveryTime(data) {
    return http({
      url: '/vivo-accounts/batchUpdateDeliveryTime',
      method: 'post',
      data,
    })
  },

  // 批量修改出价
  batchUpdateOcpxPrice(data) {
    return http({
      url: '/vivo-accounts/batchUpdateOcpxPrice',
      method: 'post',
      data,
    })
  },

  // 批量修改日限额（广告组）
  batchUpdateDailyBudget(data) {
    return http({
      url: '/vivo-accounts/batchUpdateDailyBudget',
      method: 'post',
      data,
    })
  },

  // 批量关闭广告组
  batchPauseGroups(data) {
    return http({
      url: '/vivo-accounts/batchPauseGroups',
      method: 'post',
      data,
    })
  },

  // 批量开启广告组
  batchStartGroups(data) {
    return http({
      url: '/vivo-accounts/batchStartGroups',
      method: 'post',
      data,
    })
  },

  // 批量关闭广告计划
  batchPausePlans(data) {
    return http({
      url: '/vivo-accounts/batchPausePlans',
      method: 'post',
      data,
    })
  },

  // 批量开启广告计划
  batchStartPlans(data) {
    return http({
      url: '/vivo-accounts/batchStartPlans',
      method: 'post',
      data,
    })
  },

  // 批量删除广告计划
  batchDeletePlans(data) {
    return http({
      url: '/vivo-accounts/batchDeletePlans',
      method: 'post',
      data,
    })
  },

  // 批量修改计划日限额
  batchUpdatePlanDailyBudget(data) {
    return http({
      url: '/vivo-accounts/batchUpdatePlanDailyBudget',
      method: 'post',
      data,
    })
  },

  // 批量修改定向年龄
  batchEditAge(data) {
    return http({
      url: '/vivo-accounts/batchEditAge',
      method: 'post',
      data,
    })
  },

  // 批量修改定向性别
  batchEditSex(data) {
    return http({
      url: '/vivo-accounts/batchEditSex',
      method: 'post',
      data,
    })
  },

  // 批量修改定向区域
  batchEditRegion(data) {
    return http({
      url: '/vivo-accounts/batchEditRegion',
      method: 'post',
      data,
    })
  },

  // 一键起量
  batchUpdateTogether(data) {
    return http({
      url: '/vivo-accounts/batchUpdateTogether',
      method: 'post',
      data,
    })
  },

  // 新增一键起量任务
  batchReserveFastFlowInsert(data) {
    return http({
      url: '/vivo-accounts/batchReserveFastFlow/insert',
      method: 'post',
      data,
    })
  },

  // 查询一键起量任务
  batchReserveFastFlowPage(data) {
    return http({
      url: '/vivo-accounts/batchReserveFastFlow/page',
      method: 'get',
      data,
    })
  },

  // 修改一键起量任务
  update(data) {
    return http({
      url: '/vivo-accounts/batchReserveFastFlow/update',
      method: 'post',
      data,
    })
  },

  // 删除一键起量任务
  delete(id) {
    return http({
      url: '/vivo-accounts/batchReserveFastFlow/delete',
      method: 'post',
      params: {
        id: id
      }
    })
  },

  // 查询任务日志
  logList(id) {
    return http({
      url: '/vivo-accounts/batchReserveFastFlow/log',
      method: 'get',
      params: {
        id: id
      }
    })
  },

  // 一键关闭起量
  batchCloseUpdateTogether(data) {
    return http({
      url: '/vivo-accounts/batchCloseUpdateTogether',
      method: 'post',
      data,
    })
  },

  // 查询定向包
  getAllRegionPackages(data) {
    return http({
      url: '/vivo-accounts/getAllRegionPackages',
      method: 'post',
      data,
    })
  },

  // 查询定向包
  batchBindPkg(data) {
    return http({
      url: '/vivo-accounts/batchBindPkg',
      method: 'post',
      data,
    })
  },



}
  //批量修改账户日限额
  export function  batchAccountBudget(data) {
    return http({
      url: 'https://control.zjwec.cn/api/vivo/batchUpdateAccountBudget',
      method: 'post',
      data,
    })
  }



// WEBPACK FOOTER //
// ./src/api/modules/vivoBatchEditApi.js